// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-main__header {
    font-size: 4rem;
    font-weight: 600;
    text-align: center;
    flex-shrink: 0;
}

.audit-main {
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    container-type: inline-size;
}`, "",{"version":3,"sources":["webpack://./src/app/audit/audit-main/AuditMain.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B","sourcesContent":[".audit-main__header {\r\n    font-size: 4rem;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.audit-main {\r\n    min-width: 0;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    container-type: inline-size;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
